module.exports = __webpack_public_path__ + "img/177.desserts.1af55e94.svg";